module.exports = __webpack_public_path__ + "static/media/small-diamonds.459fc78e.svg";